<template>
  <div class="bg-1 flex h-40 items-center cursor-wait">
    <div class="loading-box loading"/>
  </div>
</template>
